<template>
  <div>
    <VueApexCharts
      ref="chart"
      :options="barChart.options"
      :series="props.seriesData"
      height="350"
    ></VueApexCharts>
  </div>
</template>

<script setup>
import { reactive, defineProps } from "vue";
import VueApexCharts from "vue3-apexcharts";
const props = defineProps({
  seriesData: {
    type: Array,
    required: true,
  },
  categories: {
    type: Array,
    required: true,
  },
});

// * Bar Chart data
const barChart = reactive({
  options: {
    colors: ["#0c1e36"],

    chart: {
      toolbar: {
        show: false,
      },
      height: 350,
      type: "bar",
    },

    bar: {
      borderRadius: 10,
      dataLabels: {
        position: "top", // top, center, bottom
      },
    },

    plotOptions: {
      bar: {
        borderRadius: 5,
        dataLabels: {
          position: "top", // top, center, bottom
        },
      },
    },

    dataLabels: {
      enabled: false,
      style: {
        fontSize: "12px",
        colors: ["#0c1e36"],
      },
    },

    xaxis: {
      position: "bottom",
      axisBorder: {
        show: true,
      },
      axisTicks: {
        show: true,
      },
      crosshairs: {
        fill: {
          type: "gradient",
          gradient: {
            colorFrom: "#D8E3F0",
            colorTo: "#BED1E6",
            stops: [0, 100],
            opacityFrom: 0.6,
            opacityTo: 0.7,
          },
        },
      },
      // tooltip: {
      //   enabled: true,
      // }
    },

    yaxis: {
      axisBorder: {
        show: true,
      },
      axisTicks: {
        show: false,
      },
      labels: {
        show: true,
        formatter: function (val) {
          return val + " kWh";
        },
      },
    },
  },
});
</script>
